// extracted by mini-css-extract-plugin
module.exports = {"overlayBg":"AutoplayTimer_overlayBg_3mHz0V3"};